import { ReturnRequestLogDto } from "@babackapp/private-api-client/types";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@babackapp/ui/components/accordion";
import ActivityWrapper from "./activity-wrapper";
import ActivityIconWrapper from "./activity-icon-wrapper";
import ActivityContentWrapper from "./activity-content-wrapper";
import { ActivityItemHeader } from "./activity-item-header";
import brevoLogo from "@/assets/integrations/brevo-logo.png";

type BrevoActivityProps = {
  activity: ReturnRequestLogDto;
};

export default function BrevoActivity({ activity }: BrevoActivityProps) {
  const params = activity.params as {
    eventName: string;
    eventProperties: string;
    error?: string;
  };

  const hasError = !!params.error;

  let formattedEventProperties: string | undefined;
  if (hasError) {
    try {
      formattedEventProperties = JSON.stringify(
        JSON.parse(params.eventProperties),
        null,
        2,
      );
    } catch {
      formattedEventProperties = params.eventProperties;
    }
  }

  return (
    <ActivityWrapper>
      <ActivityIconWrapper>
        <img src={brevoLogo} className="size-4" />
      </ActivityIconWrapper>
      <ActivityContentWrapper>
        <div className="flex items-center gap-2 flex-1 justify-between w-full">
          {hasError ? (
            <Accordion type="single" collapsible className="flex-1">
              <AccordionItem value="item-1" className="border-0">
                <AccordionTrigger className="p-0 w-full">
                  <ActivityItemHeader
                    title=""
                    timestamp={activity.date}
                    description={null}
                  >
                    <div className="flex flex-col gap-0">
                      <div className="flex items-center gap-2">
                        <span>Brevo</span>
                        <span className="font-normal text-xs underline">
                          {params.eventName}
                        </span>
                        <span className="text-xs text-destructive font-medium">
                          Error
                        </span>
                      </div>
                    </div>
                  </ActivityItemHeader>
                </AccordionTrigger>
                <AccordionContent>
                  <div className="mt-2 rounded-md bg-destructive/10 border border-destructive/20 p-4 text-xs text-destructive">
                    {params.error}
                  </div>
                  <pre className="mt-2 rounded-md bg-muted p-4 text-xs overflow-x-auto whitespace-pre-wrap">
                    {formattedEventProperties}
                  </pre>
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          ) : (
            <ActivityItemHeader
              title=""
              timestamp={activity.date}
              description={null}
            >
              <div className="flex items-center gap-2">
                <span>Brevo</span>
                <span className="font-normal text-xs underline">
                  {params.eventName}
                </span>
              </div>
            </ActivityItemHeader>
          )}
        </div>
      </ActivityContentWrapper>
    </ActivityWrapper>
  );
}
